interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - currentPage) <= 1) {
      pages.push(i);
    }
  }

  const rendered: (number | string)[] = [];
  pages.forEach((page, index) => {
    if (index > 0 && page - pages[index - 1] > 1) {
      rendered.push(`gap-${page}`);
    }
    rendered.push(page);
  });

  const go = (page: number) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    onChange(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => go(currentPage - 1)}
        disabled={currentPage === 1}
        className="flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {rendered.map((item) =>
        typeof item === 'number' ? (
          <button
            key={item}
            type="button"
            onClick={() => go(item)}
            className={`h-9 min-w-9 cursor-pointer whitespace-nowrap rounded-md px-3 text-sm font-medium transition-colors ${
              item === currentPage
                ? 'bg-primary-500 text-background-50'
                : 'border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="px-1 text-sm text-foreground-400">
            ···
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => go(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}